import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Splitter, SplitterPanel } from "primereact/splitter";
import { Panel } from "primereact/panel";
import { useEffect, useState } from "react";
import { ProductCheckoutProceedModel } from "../../models/products/product-checkout-proceed-model";
import Helpers from "../../utils/helpers";

const OrderConfirmDialog = ({
  showConfirmDialog,
  hideConfirmDialog,
  orderDetails,
  orderId,
  showGetwayPage,
}: any) => {
  const header = (
    <span style={{ fontSize: "1rem" }}>Order Successfully Placed!</span>
  );

  const [orderData, setOrderData] = useState<ProductCheckoutProceedModel>(orderDetails);

  useEffect(() => {
    setOrderData(orderDetails);
  }, [orderDetails, showConfirmDialog]);



  const formatAddressLine = (parts: (string | undefined)[], separator = ', ') => {
    const validParts = parts.filter(part => part && part.trim() !== '');
    return validParts.join(separator);
  };

  const renderAddress = () => {
    if (!orderData.address) return null;

    const { address } = orderData;
    const addressLines = [
      address.address1,
      address.address2,
      address.landmark,
      formatAddressLine([
        address.areaName,
        address.subDisticName,
        address.cityName
      ]),
      formatAddressLine([
        address.stateName,
        address.countryName,
        address.zipcode ? `-${address.zipcode}` : ''
      ], ' ')
    ].filter(line => line && line.trim() !== '');

    return (
      <div className="flex flex-column align-items-left">
        {addressLines.map((line, index) => (
          <div key={`address-line-${index}`}>
            <label>{line}{index !== addressLines.length - 1 ? ',' : '.'}</label>
          </div>
        ))}
      </div>
    );
  };

  const toBePaid = orderData.grandItemTotal + orderData.courierCharges + orderData.paymentGatewayCharges + orderData.handlingCharges + orderData.packingCharges - ((orderData.rewardPointsUsed && orderData.rewardToCurrencyRatio) ? (orderData.rewardPointsUsed * orderData.rewardToCurrencyRatio) : 0);

  const showProceedToPayment = orderData.paymentOption.mode === "Online Payment" && toBePaid > 0;

  const footer = (
    <div className="flex flex-wrap justify-content-end gap-2" style={{ padding: "0.7rem" }}>
      {showProceedToPayment ? (
        <Button
          label="Proceed To Payment"
          icon="pi pi-paypal"
          className="p-button-secondary"
          onClick={showGetwayPage}
          severity="success"
        />
      ) : (
        <Button
          label="Close"
          icon="pi pi-times"
          className="p-button-secondary"
          onClick={hideConfirmDialog}
          severity="danger"
        />
      )}
    </div>
  );

  return (
    <Dialog
      visible={showConfirmDialog}
      header={header}
      className="custom-dialog checkout-prod"
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      modal
      onHide={hideConfirmDialog}
      footer={footer}
    >
      <div className="flex flex-column gap-1" style={{ padding: "0 1rem" }}>
        <span className="font-bold text-green2">Order #: {orderId}</span>
        <span className="font-bold text-green2">Order Date & Time: {new Date().toLocaleString()}</span>
        <span className="font-bold text-green2">
          Estimated Delivery Date (On or before): {Helpers.getNext7Days().toString()}
        </span>
        <Splitter>
          <SplitterPanel className="flex">
            <Panel header="Shipping Address" style={{ width: "20rem" }}>
              {orderData.address ? (
                <div className="flex flex-column align-items-left">
                  {orderData.address.address1 && (
                    <div>
                      <label htmlFor="name">{orderData.address.address1}</label>
                    </div>
                  )}
                  {orderData.address.address2 && orderData.address.address2.trim() !== "" && (
                    <div>
                      <label htmlFor="name">{orderData.address.address2}</label>
                    </div>
                  )}
                  {orderData.address.landmark && orderData.address.landmark.trim() !== "" && (
                    <div>
                      <label htmlFor="name">{orderData.address.landmark}</label>
                    </div>
                  )}
                  {(orderData.address.areaName || orderData.address.cityName || orderData.address.stateName || orderData.address.countryName || orderData.address.zipcode) && (
                    <div>
                      <label htmlFor="name">
                        {[
                          orderData.address.areaName,
                          orderData.address.subDisticName,
                          orderData.address.cityName,
                          orderData.address.stateName,
                          orderData.address.countryName
                        ]
                          .filter(part => part && part.trim() !== "")
                          .join(", ")}
                        {orderData.address.zipcode ? ` - ${orderData.address.zipcode}` : ""}
                      </label>
                    </div>
                  )}
                </div>
              ) : null}
            </Panel>
          </SplitterPanel>
          <SplitterPanel className="flex">
            <Panel header="Payment Method" style={{ width: "20rem" }}>
              {orderData.paymentOption ? (
                <div className="flex flex-column align-items-left">
                  <div>
                    <label htmlFor="name">
                      Mode : {orderData.paymentOption.mode}.
                    </label>
                  </div>
                  <div>
                    <label htmlFor="name">Status : Order Placed.</label>
                  </div>
                </div>
              ) : null}
            </Panel>
          </SplitterPanel>
        </Splitter>
        <Panel header="Order Summary" toggleable>
          <div className="flex flex-column align-items-left">
            <div>
              <label htmlFor="name">
                Total Products : {/* LT */}
                <span className="text-green2">{orderData.items.length}</span>
              </label>
            </div>
            <div>
              <label htmlFor="name">
                Taxable Value : {/* LT */}
                <span className="text-green2">
                  {Helpers.formatAmountInINR(orderData.totalItemCost)}
                </span>
              </label>
            </div>
            <div>
              <label htmlFor="name">
                Total Tax : {/* LT */}
                <span className="text-green2">
                  {Helpers.formatAmountInINR(orderData.totalTax)}
                </span>
              </label>
            </div>
            <div>
              <label htmlFor="name">
                Courier Charges : {/* LT */}
                <span className="text-green2">
                  {Helpers.formatAmountInINR(orderData.courierCharges)}
                </span>
              </label>
            </div>
            <div>
              <label htmlFor="name">
                Delivery Handling Charges : {/* LT */}
                <span className="text-green2">
                  {Helpers.formatAmountInINR(orderData.deliveryHandlingCharges)}
                </span>
              </label>
            </div>
            <div>
              <label htmlFor="name">
                Packing Charges : {/* LT */}
                <span className="text-green2">
                  {Helpers.formatAmountInINR(orderData.packingCharges)}
                </span>
              </label>
            </div>
            <div>
              <label htmlFor="name">
                Payment Gateway Charges : {/* LT */}
                <span className="text-green2">
                  {Helpers.formatAmountInINR(orderData.paymentGatewayCharges)}
                </span>
              </label>
            </div>
            {(orderData.rewardPointsUsed ) && (
              <div>
                <label htmlFor="name">
                  Reward Discount : {/* LT */}
                  <span className="text-green2">
                    {Helpers.formatAmountInINR(orderData.rewardPointsUsed * (orderData?.rewardToCurrencyRatio ?? 0))}
                  </span>
                </label>
              </div>
            )}
            <div>
              <label htmlFor="name">
                To be Paid :
                <span className="text-green2">
                  {Helpers.formatAmountInINR(toBePaid)}
                </span>
              </label>
            </div>
          </div>
        </Panel>
      </div>
    </Dialog>
  );
};

export default OrderConfirmDialog;